import React from 'react';
import styles from '../../components/Description/Description.module.scss';

export const Description: React.FC<{ description: string }> = ({ description }) => {
  return <div className={styles.description}>{description}</div>;
};
